<template>
  <div>
    <vendor-form />
  </div>
</template>

<script>
import VendorForm from '../comonents/VendorForm.vue'

export default {
  components: {
    VendorForm,
  },
}
</script>

<style>

</style>
